import React from 'react';
import PropTypes from 'prop-types';
import Toggle from '@adsk/alloy-react-toggle';
import Tooltip from '@adsk/alloy-react-tooltip';
import { useLocale } from '@adsk/alloy-react-helpers';
import { ACCOUNT_OFFERING_TYPES } from '../../constants';
import {
  licensesRemainingStyle,
  toggleLabelNameStyle,
  toggleStyle,
  toggleContainerStyle,
} from './styles';

const OfferingToggle = ({
  checked,
  customizedDisabledTextKey,
  customizedLabelDescriptionKey,
  disabled,
  label,
  licenseType,
  licensesAvailable,
  onChange,
}) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));

  let licenseText = `${licensesAvailable} ${T.translate(
    'MEMBER_SUBSCRIPTION_AVAILABLE_TEXT'
  )}`;

  const isTokenFlex =
    licenseType === 'token-flex' ||
    licenseType === ACCOUNT_OFFERING_TYPES.TOKEN_FLEX;

  if (disabled && customizedLabelDescriptionKey) {
    licenseText = T.translate(customizedLabelDescriptionKey);
  } else if (isTokenFlex) {
    licenseText = T.translate('MEMBER_SUBSCRIPTION_DROPDOWN_TOKEN_FLEX');
  }

  const renderToggle = () => (
    <Toggle checked={checked} onChange={onChange} disabled={disabled} />
  );

  return (
    <div css={toggleStyle}>
      <div>
        <div style={toggleLabelNameStyle}>{label}</div>
        <div css={licensesRemainingStyle}>{licenseText}</div>
      </div>
      <div css={toggleContainerStyle}>
        {disabled ? (
          <Tooltip
            content={T.translate(customizedDisabledTextKey, {
              offeringName: label,
              name: licenseText,
            })}
            placement={Tooltip.PLACEMENTS.BOTTOM_END}
          >
            {renderToggle()}
          </Tooltip>
        ) : (
          <div>{renderToggle()}</div>
        )}
      </div>
    </div>
  );
};

OfferingToggle.propTypes = {
  checked: PropTypes.bool,
  customizedDisabledTextKey: PropTypes.string,
  customizedLabelDescriptionKey: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  licensesAvailable: PropTypes.number,
  licenseType: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

OfferingToggle.defaultProps = {
  checked: false,
  customizedDisabledTextKey: '',
  customizedLabelDescriptionKey: '',
  disabled: false,
  label: '',
  licensesAvailable: 0,
};

export default OfferingToggle;
